const isIE =
  navigator.appName === 'Microsoft Internet Explorer' ||
  !!(navigator.userAgent.match(/Trident/) ||
  navigator.userAgent.match(/rv:11/));

export { isIE }
